// AI Generated Component
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { LabelsRoutingModule } from './labels-routing.module';
import { LabelsComponent } from './labels.component';
import { LabelBlockedByDomainGroupsComponent } from './modals/label-blocked-by-domain-groups-modal.component';

// Import shared components and modules
import { SharedModule } from '@client/ng2/shared/shared.module';
import { LayoutModule, MonEventTriggerModule, TableModule, MonTableSortModule } from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { MonLabelsModule } from '@client/ng2/modules/labels/labels.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';
import { IconsModule } from '@client/ng2/layout/icons/icons.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        LabelsComponent,
        LabelBlockedByDomainGroupsComponent,
    ],
    imports: [
        FormsModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        UIRouterModule,
        LabelsRoutingModule,
        SharedModule,
        TableModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
        MonEventTriggerModule,
        MonLabelsModule,
        MonTableSortModule,
        ExtensionModule,
        ActiveFeaturePipe,
        IconsModule,
    ],
    providers: [],
})
export class LabelsModule {}
